import { collection } from "firebase/firestore"
import { firestore } from "../firebase"

const getNewsCollRef = () => {
  return collection(firestore, 'news')
}

export default getNewsCollRef;